import { Favorite } from 'state/assets/AssetTypes';
import { Subscription, SubscriptionTiers } from 'state/subscription/SubscriptionTypes';

export interface User {
   _id: string;
   cognitoId: string;
   email: string;
   phone?: string;
   firstName?: string;
   verified: boolean;
   isLegacy: boolean;
   lastName?: string;
   fullName?: string;
   isFreeTrialEligible?: boolean;
   favoriteConfigs: Favorite[];
   subscription: Subscription[];
   updatedAt?: string;
   adminStatus?: AdminStatus;
   premiumOverride?: boolean;
   promoEligibility?: PromoEligibility;
   macAddresses?: string[];
}

export type UserRole = 'admin' | 'customer';

export enum AdminStatus {
   active = 'ACTIVE',
   disabled = 'DISABLED',
   none = 'NONE',
}

export enum PromoEligibility {
   none = 'NONE',
   twoMonths = 'TWO_MONTHS',
   sixMonths = 'SIX_MONTHS',
}

export enum UserKeys {
   email = 'email',
   firstName = 'firstName',
   lastName = 'lastName',
   password = 'password',
   newPassword = 'newPassword',
   username = 'username',
   phone = 'phone',
}

export interface CreateUserRequest {
   firstName: string;
   lastName?: string;
   email: string;
   phone: string;
   subscriptionTier?: SubscriptionTiers;
   expirationDate?: string; // ISO Date
   adminStatus?: AdminStatus;
   premiumOverride?: boolean;
   promoEligibility?: PromoEligibility;
}

export interface CreateUserResponse {
   createdUser: User;
}

export interface UserResponse {
   [key: string]: User;
}

export type UpdateUserRequest = Partial<Omit<CreateUserRequest, 'subscriptionTier' | 'expirationDate'> & { isLegacy: boolean }>;

export interface UpdateUserResponse {
   updatedUser: User;
}

export interface GetUsersResponse {
   users: User[];
}

/**
 * APP USER (Profile & Favorites)
 */
export interface UpdateProfileRequest {
   firstName?: string;
   lastName?: string;
   email?: string;
   phone?: string;
   macAddresses?: string[];
}
export interface UpdateProfileResponse {
   updatedUser: User;
}

export interface GetUsersResponse {
   users: User[];
   limit: number;
   totalDocs: number;
   currentPage: number;
   totalPages: number;
}

export interface GetUsersQueryStrings {
   type: UserRole;
   limit?: number;
   page: number;
   search?: string;
   searchField?: SearchField;
   sortField?: SortField;
   sortOrder?: SortOrder;
}

export enum SearchField {
   lastName = 'lastName',
   firstName = 'firstName',
   email = 'email',
   phone = 'phone',
}

export enum SortField {
   lastName = 'lastName',
   firstName = 'firstName',
   email = 'email',
   createdAt = 'createdAt',
}

export enum SortOrder {
   ascending = 'ascending',
   descending = 'descending',
}
